import { render, staticRenderFns } from "./carousel-text.vue?vue&type=template&id=94d238b6&"
import script from "./carousel-text.vue?vue&type=script&lang=js&"
export * from "./carousel-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94d238b6')) {
      api.createRecord('94d238b6', component.options)
    } else {
      api.reload('94d238b6', component.options)
    }
    module.hot.accept("./carousel-text.vue?vue&type=template&id=94d238b6&", function () {
      api.rerender('94d238b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/carousel-text.vue"
export default component.exports